<template>
	<div>
		<vue-draggable-resizable
			class="element-position-lowerthird "
			:style="style"
			:class="className"
			v-if="status ==='preview' && isRtmp"
			:draggable="status ==='preview' && !item.is_locked && !content.isPosition"
			:resizable="status ==='preview' && !item.is_locked && !content.isPosition"
			:x="content.x"
			:y="content.y"
			:w="content.width"
			:h="content.height"
			@dragstop="onDragstop"
			@resizestop="onResizestop"
			@dragging="onDrag"
			@resizing="onResize"
			:lock-aspect-ratio="isLockRatio"
			:preventActiveBehavior="true"
			:parent="false">
			<div :style="styleWithCroppingOuter" >
				<!-- <div class="p-8 text-center w-100 mt-2 color-white" >
					<div class="is-loading loading-iframe"></div>
				</div> -->
				<!-- <iframe
					:style="styleWithCropping"
					:id="rtmpElementId"
					scrolling="no"
					:src="url"
					:width="content.width"
					allow="autoplay"
					ref="rtmpPreviewCustBrowser"
				/> -->
				<video class="video-js vjs-16-9"
					:style="styleWithCropping"
					:id="rtmpElementId"
					scrolling="no"
					:src="url"
					:width="content.width"
					allow="autoplay"
					ref="rtmpPreviewCustBrowser">
				</video>
				<!-- <div v-show="isShowLabel" class="text-center label-custom-browser" :style="{ zIndex: localItem.layer_index + 1, fontSize: content.width / 80 + 'px'}">
					<div>{{localItem && localItem.name ? localItem.name : "Default custom browser"}}</div>
				</div> -->
			</div>
		</vue-draggable-resizable>
		<div v-if="status ==='live' && isRtmp " :style="styleOutlineLive">
			<div :style="styleWithCroppingOuter" v-if="status ==='live' && isRtmp" ref="liveContainer">
				<!-- <div class="p-8 text-center w-100 mt-2 color-white">
					<div class="is-loading loading-iframe"></div>
				</div> -->
				<!-- <iframe
					v-if="status ==='live' && isRtmp"
					:style="styleLive"
					:id="rtmpElementId"
					scrolling="no"
					:src="url"
					class="element-position"
					:width="content.width"
					height="auto"
					:class="className"
					allow="autoplay"
					ref="rtmpLiveCustBrowser"
				/> -->
				<video class="video-js vjs-16-9"
					:style="styleLive"
					:id="rtmpElementId"
					scrolling="no"
					:width="content.width"
					height="auto"
					:class="className"
					ref="rtmpLiveCustBrowser">
				</video>
				<!-- <div v-show="isShowLabel" class="text-center label-custom-browser" :style="{ zIndex: localItem.layer_index + 1, fontSize: content.width / 80 + 'px'}">
					<div>{{localItem && localItem.name ? localItem.name : "Default custom browser"}}</div>
				</div> -->
			</div>
		</div>
		<!-- Video Element -->
	</div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
// import axios from 'axios';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ElementRtmp',
	components: {
		VueDraggableResizable,
	},
	data() {
		return {
			localItem: null,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
				if (this.status === 'live') {
					this.dispose();
					this.init();
				}
			}
		},
	},
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	methods: {
		init() {
			// eslint-disable-next-line no-undef
			const player = videojs(this.rtmpElementId);
			player.src({
				src: this.url,
				type: 'application/x-mpegURL',
			});
			const playPromise = player.play();

			if (playPromise !== undefined) {
				// eslint-disable-next-line no-unused-vars
				playPromise.then((_) => {
					// Automatic playback started!
					// Show playing UI.
				})
					.catch(() => {
						// Auto-play was prevented
						// Show paused UI.
					});
			}
			player.on('error', (e) => {
				console.log(e);
			});
		},
		dispose() {
			// eslint-disable-next-line no-undef
			videojs(this.rtmpElementId).dispose();
			if (this.status === 'live') {
				const video = document.createElement('video');
				video.id = this.rtmpElementId;
				if (this.status === 'live') Object.assign(video.style, this.styleLive);
				video.width = `${this.content.width}`;
				video.className = 'video-js';
				this.$refs.liveContainer.appendChild(video);
			}
		},
		showOnLoadLive() {
			this.showIframeLive = true;
		},
		showOnLoadPreview() {
			this.showIframePreview = true;
		},
		checkUrlPreview() {
			this.timepastPreview = false;
			this.timeoutLive = setTimeout(() => {
				this.timepastPreview = true;
			}, 250);
			if (this.$refs.iframePreviewCustBrowser.attachEvent) {
				this.$refs.iframePreviewCustBrowser.attachEvent('onload', () => {
					if (this.timepastPreview) {
						this.showIframePreview = true;
						this.errorIframePreview = false;
					} else {
						this.errorIframePreview = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				});
			} else {
				this.$refs.iframePreviewCustBrowser.onload = () => {
					if (this.timepastPreview) {
						this.errorIframePreview = false;
						this.showIframePreview = true;
					} else {
						this.errorIframePreview = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				};
			}
		},

		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {
		},
		onResize(x, y, width, height) {
			this.content.width = width;
			this.content.height = height;
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	computed: {
		content() {
			return this.item.content && this.item.content !== ''
				? JSON.parse(this.item.content) : {};
		},
		playableRtmpUrl() {
			return `https://ingest.golightstream.com/hls/${this.content.key}.m3u8`;
		},
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		rtmpElementId() {
			return `rtmp${this.localItem.slug}-${this.localItem.id}`;
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			return style;
		},
		styleWithCroppingOuter() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.isEnableBorder) {
				if (content.isEnableCrop) {
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
					style.overflow = 'hidden';
				} else {
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = 'inset(0px 0px 0px 0px)';
					style.overflow = 'hidden';
				}
			}
			return style;
		},
		styleWithCropping() {
			const style = {};
			style.position = 'absolute';
			style.pointerEvents = 'none';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.isEnableCrop) {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				const top = content.cropTop || 0;
				const bottom = content.cropBottom || 0;
				const left = content.cropLeft || 0;
				const right = content.cropRight || 0;
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
			} else {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = 'inset(0px 0px 0px 0px)';
			}
			return style;
		},
		styleOutlineLive() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			style.position = 'absolute';
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
				if (content.width) style.width = `${content.width}px`;
				if (content.height) style.height = `${content.height}px`;
				if (content.y) style.top = `${content.y}px`;
				if (content.x) style.left = `${content.x}px`;
				if (content.isEnableCrop) {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		isRtmp() {
			return this.localItem.type === 'lightstream_rtmp';
		},
		url() {
			return `https://ingest.golightstream.com/hls/${this.content.key}.m3u8`;
		},
		isShowLabel() {
			return this.content && this.content.isShowLabel ? this.content.isShowLabel : 0;
		},
	},
	mounted() {
		this.init();
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	destroyed() {},
	beforeDestroy() {
		// eslint-disable-next-line no-undef
		this.dispose();
	},
};
</script>
